export async function configureRevenueCat(userId: string): Promise<void> {
  if (import.meta.env.VITE_PLATFORM === 'MOBILE') {
    const { configureRevenueCatCapacitor } =
      await import('./configureRevenueCatCapacitor');
    return configureRevenueCatCapacitor(userId);
  }
  const { configureRevenueCatJs } = await import('./configureRevenueCatJs');
  configureRevenueCatJs(userId);
}
